

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { DashboardService, DashboardServiceSymbol } from '@/app/dashboard/dashboard-service';
import { ChapterProgress, DropdownItem, SortType, BookmarkItem } from '@/app/shared/models';
import { defaultCourseImageUri } from '@/app/shared/utils/content-utils';
import { getPageLocationByHref, navigateToPage } from '@/app/shared/utils/route-utils';
import { TrackingService2, TrackingService2Symbol } from '@/app/tracking/api'
import aspectStoreModule from '@/app/aspect/apsect-state';
import WrapperSimpleComponent from '@/app/shared/components/wrapper/wrapper-simple-component.vue';
import WrapperCommonComponent from '@/app/shared/components/wrapper/wrapper-common-component.vue';
import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';
import UiIconComponent from '@/app/shared/components/ui/ui-icon-component.vue';
import UiScrollableComponent from '@/app/shared/components/ui/ui-scrollable-component.vue';
import UiDropDownComponent from '@/app/shared/components/ui/ui-drop-down-component.vue';
import UiPagerComponent from '@/app/shared/components/ui/ui-pager-component.vue';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";
import { queryBookmarkItem } from '@/app/shared/utils/bookmark-utils';

const DEFAULT_PER_PAGE: number = 3;
const IS_SORTING_ENABLED = false; // REVIEW(szazo): Disabled, because lastActivityTimestamp is not set

@Component({
  components: {
    WrapperSimpleComponent,
    WrapperCommonComponent,
    UiStatusBarComponent,
    UiIconComponent,
    UiScrollableComponent,
    UiDropDownComponent,
    UiPagerComponent,
    HelpPopupComponent
  }
})
export default class DashboardChapterProgressComponent extends Vue {
  @Prop()
  public chapterProgressItems: ChapterProgress[];

  public bookmarkItem: BookmarkItem|null = null;
  public currentPage: number = 1;
  public paginatorActions: any;

  @lazyInject(DashboardServiceSymbol)
  private dashboardService: DashboardService;

  @lazyInject(TrackingService2Symbol)
  private trackingService: TrackingService2

  public get pageCount(): number {
    return Math.ceil(this.chapterProgressItems.length / this.perPage);
  }

  public get dropdownItems(): DropdownItem[] {
    return [
      { id: SortType.index, label: this.$t('dashboard.sort_by_order') },
      { id: SortType.recent, label: this.$t('dashboard.sort_by_last') }
    ];
  }

  public get pagedItems(): ChapterProgress[] {
    const start: number = (this.currentPage - 1) * this.perPage;
    const end: number = start + this.perPage;
    return this.chapterProgressItems.slice(start, end);
  }

  private get perPage(): number {
    if (this.bookmarkItem === null) {
      return 4;
    }

    return DEFAULT_PER_PAGE;
  }

  private get isSortingEnabled() {
    return IS_SORTING_ENABLED;
  }

  public async mounted() {
    this.bookmarkItem = await queryBookmarkItem(this.trackingService);

  }

  public async navigateToPage(page: string, sectionId: string, isChild: boolean) {
    return navigateToPage(page, sectionId, isChild)
  }

  public getPageLocationByHref(href: string) {
    return getPageLocationByHref(href);
  }

  public onSortItemSelected(sortType: SortType): void {
    this.currentPage = 1;

    this.chapterProgressItems = this.dashboardService.sortChapterProgressItems(
      this.chapterProgressItems,
      sortType
    );
  }

  public getChapterSectionImageUri(imageUri: string|null): string|null {
    if (imageUri === null) {
      if (aspectStoreModule.selectedCourseAspectInstance !== null
        && aspectStoreModule.selectedCourseAspectInstance.sectionImageUri !== null) {
        imageUri = aspectStoreModule.selectedCourseAspectInstance.sectionImageUri;
      } else {
        imageUri = defaultCourseImageUri();
      }
    }

    return imageUri;
  }

  public navigateIfNeeded(e: any, index: number, progIndex: number) {
    if (e.keyCode === 9) {
      const wrapperEl = this.$refs['card-wrapper'] as HTMLDivElement;

      if (!e.shiftKey && index >= this.perPage - 1 && progIndex < this.chapterProgressItems.length) {
        e.preventDefault();

        this.paginatorActions.next();

        this.$nextTick(() => {
          wrapperEl.querySelectorAll('a')[this.bookmarkItem ? 1 : 0].focus();
        })
      } else if (e.shiftKey && index <= 0 && progIndex > 0 ) {
        e.preventDefault();

        this.paginatorActions.prev();

        this.$nextTick(() => {
          const siblings = wrapperEl.querySelectorAll('a');
          siblings[siblings.length - 1].focus();
        });
      }
    }
  }
}
